import {getTokenData} from './locale-storage-service';

export const getUrlForCommunity = (): string => {
  const tokenData = getTokenData();
  const appCircleLinkPart1 = process.env.REACT_APP_CIRCLE_LINK_PART_1 || '';
  const appCircleLinkPart2 = process.env.REACT_APP_CIRCLE_LINK_PART_2 || '';
  const token = tokenData.idToken;

  return `${appCircleLinkPart1}${token}${appCircleLinkPart2}`;
};